import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { ModelService } from 'src/app/core/services/model.service';
import { MailService } from 'src/app/core/services/mail.service';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { SubscriptionWInstance } from '../subscription-management/subscription-management.component';
import { ServiceUtilsService } from 'src/app/core/services/service-utils.service';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { IndustryProductID } from 'src/app/model/industry';
import { Mode } from 'src/app/model/subscription';
import { StoreRolesService } from 'src/app/core/services/store-role.service';

@Component({
    selector: 'ms-multicompany',
    templateUrl: './multicompany.component.html',
    styleUrls: ['./multicompany.component.scss'],
})
export class MulticompanyComponent implements OnInit, OnChanges {
    subscriptionFound: boolean = true;
    public subscriptionT: SubscriptionWInstance[];
    dataSourceSubscription: MatTableDataSource<SubscriptionWInstance>;
    displayedColumnsSubscription: string[] = ['SubscriptionKey'];
    searchSubscriptionText: string = '';
    isComponentInitialized = false;
    mail: string = '';
    @Input() havePermission: boolean;
    @Input() currentsubscriptionKey: string;
    @Input() currentsubscriptionDescri: string;
    @Input() productID: string;
    @Input() subMode: string;
    @Output() subKey = new EventEmitter<string>();

    _subscriptionPaginator: MatPaginator;
    @ViewChild('subscriptionPaginator') set accountsPaginator(contentSubscription: MatPaginator) {
        if (contentSubscription) {
            // initially setter gets called with undefined
            this._subscriptionPaginator = contentSubscription;
            if (this.dataSourceSubscription) {
                this.dataSourceSubscription.paginator = this._subscriptionPaginator;
            }
        }
    }

    _subscriptionSort: MatSort;
    @ViewChild(MatSort) set subscriptionSort(contentSubscription: MatSort) {
        if (contentSubscription) {
            // initially setter gets called with undefined
            this._subscriptionSort = contentSubscription;
            if (this.dataSourceSubscription) {
                this.dataSourceSubscription.sort = this._subscriptionSort;
            }
        }
    }

    constructor(
        private router: Router,
        private subscriptionService: SubscriptionService,
        private workFlow: WorkFlowService,
        private variable: TranslatedVariables,
        private serviceUtilsService: ServiceUtilsService,
        private mailService: MailService,
        public storeRolesService: StoreRolesService
    ) {}

    async ngOnInit() {
        this.isComponentInitialized = true;
        await this.loadInfo();
    }

    async ngOnChanges() {
        if (this.isComponentInitialized) {
            await this.loadInfo();
        }
    }

    async loadInfo() {
        this.subscriptionService.getSlaveSubscription(this.currentsubscriptionKey).subscribe(
            (res) => {
                const opRes: boolean = res['Result'];
                if (!opRes) {
                    this.workFlow.showMessage(this.variable.errorTitle, res['Message']);
                    this.subscriptionFound = false;
                    return;
                } else if (res['Content'].length === 0) {
                    this.subscriptionFound = false;
                    return;
                } else {
                    this.subscriptionFound = true;
                    this.subscriptionT = res['Content'];
                    this.dataSourceSubscription = new MatTableDataSource<SubscriptionWInstance>(this.subscriptionT);
                }
            },
            (err) => {
                this.workFlow.showMessage(this.variable.errorTitle, err.message);
            }
        );
        //mail
        let opResult = await this.mailService.getEmailAddressByPaiWebSiteInfo('SALEORDERS');
        let mail: string[] = opResult.Result ? (opResult.Content as string[]) : [];
        let i = 0;
        this.mail = '';
        mail.forEach((element) => {
            this.mail = i > mail.length ? this.mail + element + ';' : this.mail + element;
            i++;
        });
    }

    redirectToSlaveManagement() {
        if (this.currentsubscriptionKey) {
            this.router.navigate(['/store/SlaveManagement'], {
                queryParams: {
                    subKey: btoa(this.currentsubscriptionKey),
                    subDescription: btoa(this.currentsubscriptionDescri),
                    subMode: this.subMode,
                    productID: this.productID,
                },
            });
        }
    }

    clearSubscriptionSearch() {
        this.searchSubscriptionText = '';
        this.dataSourceSubscription.filter = this.searchSubscriptionText.trim().toLowerCase();
        this.subscriptionFound = true;
    }

    applySubscriptionSearch(event: any) {
        let filterValue: string;
        filterValue = (event.target as HTMLInputElement).value;
        this.dataSourceSubscription.filterPredicate = function (data, filter: string): boolean {
            return data.Description.toLowerCase().includes(filter) || data.SubscriptionKey.toLowerCase().includes(filter);
        };
        this.dataSourceSubscription.filter = filterValue.trim().toLowerCase();

        if (this.dataSourceSubscription.filteredData.length === 0) {
            this.subscriptionFound = false;
        } else {
            this.subscriptionFound = true;
        }
    }

    onClickSubKey(subKey: string) {
        this.subKey.emit(subKey);
    }
    setDisabled() {
        if (!this.productID || this.productID.length == 0) return false;

        if (!this.storeRolesService.IsInternal) {
            if (this.productID == IndustryProductID.MC && this.subMode != Mode.rtm.toString()) {
                return true;
            } else {
                return false;
            }
        }
        if (this.storeRolesService.IsInternal) {
            if (this.productID == IndustryProductID.MW) return false;
            else return true;
        } else return true;
    }
}
